import { render } from "./show-item.vue?vue&type=template&id=4a1a0c63&scoped=true"
import script from "./show-item.vue?vue&type=script&lang=js"
export * from "./show-item.vue?vue&type=script&lang=js"

import "./show-item.vue?vue&type=style&index=0&id=4a1a0c63&lang=scss&scoped=true"

import exportComponent from "/Users/shuaqq/Desktop/quickadmin/vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a1a0c63"]])

export default __exports__